var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEh = function SvgEh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-158.67 0H524v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(148.75) scale(.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-180 0H844v256H-180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107b00",
    d: "M-180 256H844v256H-180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-180 169.31H844v176.13H-180z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.98 195.55c-45.202-19.423-84.107 20.644-84.063 58.085.046 39.158 38.02 80.92 86.168 62.43-34.087-10.037-48.156-35.215-48.15-60.68-.245-25.216 15.887-54.54 46.045-59.835z",
    fill: "#f0f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1800",
    d: "M363.145 294.214l-25.835-18.868-25.993 18.898 9.963-30.403-26-18.87 31.984.07 9.93-30.552 9.816 30.435 32.115.005-25.924 18.735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.34 315.65c-50.517 17.536-88.554-20.48-89.216-59.456-.66-38.976 37.59-79.167 89.473-60.865-29.355 4.352-50.912 30.08-51.17 59.168-.196 21.994 12.812 53.345 50.913 61.152zM-179.98 0l348.61 256.62L-180 512l.002-509.38.015-2.622z",
    fill: "red"
  }))));
};
export default __webpack_public_path__ + "assets/7efa0aecd0aedad3377642a658c8d3ee.svg";
export { SvgEh as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/eh.svg